import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DashboardServices } from "./DashboardService";
import { toast } from "react-toastify";

export const GetSLADashboard = createAsyncThunk(
  "dashboard/GetSLADashboard",
  async (email, { rejectWithValue }) => {
    try {
      const response = await DashboardServices.dashboard().CheckCurrentSLA(
        email
      );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  sla_data: {},
};

export const DashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(GetSLADashboard.pending, (state) => {
        return {
          ...state,
          isSubmitting: true,
        };
      })
      .addCase(GetSLADashboard.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccessful: true,
          isSubmitting: false,
          sla_data: action.payload,
        };
      })
      .addCase(GetSLADashboard.rejected, (state, action) => {
        return {
          ...state,
          isSubmitting: false,
          error: action.payload,
        };
      });
  },
});

export default DashboardSlice.reducer;
